import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _defineProperty from "/usr/src/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import BasicSEO from '../../components/seo/BasicSEO';
import CollectionHero from '../../components/collection-hero/collection-hero';
import SortFilterModalSheet from '../../components/sort-filter-modal-sheet/sort-filter-modal-sheet';
import { UtilsSeparator } from '@vc-workspace/utils-separator';
import { Pagination, DEFAULT_PAGINATION_LIMIT } from '@vc-workspace/pagination';
import { DIMENSIONS } from '@vc-workspace/utils-dimens';
import { UtilsInfiniteScroll } from '@vc-workspace/utils-infinite-scroll';
import { UtilsStickyBottomCta } from '@vc-workspace/utils-sticky-bottom-cta';
import { DesktopFooter } from '@vc-workspace/desktop-footer';
import { MobileFooter } from '@vc-workspace/mobile-footer';
import { getQueryValueAsString } from '@vc-workspace/utils-helpers';
import { FilterTypes, CategoryFilterKey, SortByKey, PriceFilterKey, DiscountFilterKey, PageTypes, SourceKey, SourceNameKey } from '@vc-workspace/utils-constants';
import { useEffect } from 'react';
import { AmplitudeEventNames, sendAmplitudeData } from '@vc-workspace/utils-amplitude';
import GlobalContextWrapper from '../../components/global-context-wrapper/global-context-wrapper';
import FilterModalDialog from '../../components/filter-modal-dialog/filter-modal-dialog';
import CategoryFilters from '../../components/category-filters/category-filters';
import { getProducts } from '@vc-workspace/data-adapter';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getFiltersPayload } from '../../components/helpers/helpers';
import ProductStackList from '../../components/product-stack-list/product-stack-list';
import { RetailEventTypes, trackGARetailEvent } from '@vc-workspace/utils-ga';

function fetchProductsForPages(currPage, context) {
  if (!currPage) {
    currPage = 1;
  }

  var reqPayload = _objectSpread({
    siaCollectionUsId: context.params[1],
    start: DEFAULT_PAGINATION_LIMIT * (currPage - 1),
    limit: DEFAULT_PAGINATION_LIMIT,
    getFilters: true
  }, getFiltersPayload(context));

  return getProducts(reqPayload);
}

export var __N_SSP = true;
export function DesktopCollectionPage(props) {
  var _props$serverResponse, _props$serverResponse2;

  useEffect(function () {
    var siaCollection = props.serverResponse.siaCollection;
    sendAmplitudeData(AmplitudeEventNames.PAGE_VIEWED, {
      page_type: PageTypes.MARKETPLACE_COLLECTION_PAGE,
      page_name: siaCollection.title,
      page_identifier: siaCollection.usId,
      page_num: props.currPage,
      price_filter: getQueryValueAsString(props.context.query, PriceFilterKey),
      discount_filter: getQueryValueAsString(props.context.query, DiscountFilterKey),
      sort_filter: getQueryValueAsString(props.context.query, SortByKey),
      category_filter: getQueryValueAsString(props.context.query, CategoryFilterKey),
      source: getQueryValueAsString(props.context.query, SourceKey),
      source_name: getQueryValueAsString(props.context.query, SourceNameKey)
    });
    var siaCategoriesHierarchy = [];
    props.serverResponse.sias.forEach(function (sia) {
      var _sia$itemDetail$categ;

      (_sia$itemDetail$categ = sia.itemDetail.categoriesTree) === null || _sia$itemDetail$categ === void 0 ? void 0 : _sia$itemDetail$categ.forEach(function (categoryTreeItem) {
        var l0Category = categoryTreeItem.filter(function (item) {
          return item.level === 0;
        })[0];
        var l1Category = categoryTreeItem.filter(function (item) {
          return item.level === 1;
        })[0];
        var l2Category = categoryTreeItem.filter(function (item) {
          return item.level === 2;
        })[0];
        siaCategoriesHierarchy.push("".concat(l0Category.name, " > ").concat(l1Category.name, " > ").concat(l2Category.name));
      });
    });
    var payload = {
      eventType: RetailEventTypes.CATEGORY_PAGE_VIEW,
      pageViewId: props.serverResponse.siaCollection.usId,
      pageCategories: siaCategoriesHierarchy,
      productDetails: props.serverResponse.sias.map(function (sia) {
        if (sia.itemDetail.variations && sia.itemDetail.variations.length) {
          return {
            product: {
              id: "sia-".concat(sia._id, "-var-").concat(sia.itemDetail.variations[0].uuid)
            }
          };
        }

        return {
          product: {
            id: "sia-".concat(sia._id)
          }
        };
      })
    };

    if (props.userId) {
      payload.userInfo = {
        userId: props.userId
      };
    }

    trackGARetailEvent(payload);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(BasicSEO, {
      title: props.serverResponse.siaCollection.seoMeta ? props.serverResponse.siaCollection.seoMeta.title : props.serverResponse.siaCollection.title,
      description: ((_props$serverResponse = props.serverResponse.siaCollection.seoMeta) === null || _props$serverResponse === void 0 ? void 0 : _props$serverResponse.description) || props.serverResponse.siaCollection.info || '',
      keywords: ((_props$serverResponse2 = props.serverResponse.siaCollection.seoMeta) === null || _props$serverResponse2 === void 0 ? void 0 : _props$serverResponse2.keywords) || ''
    }), /*#__PURE__*/_jsx(CollectionHero, {
      page: props.serverResponse.siaCollection,
      filters: props.serverResponse.filters,
      context: props.context,
      siasCount: props.serverResponse.siasCount
    }), /*#__PURE__*/_jsx("div", {
      className: "page-cushion-container",
      children: /*#__PURE__*/_jsxs("div", {
        className: "pure-g",
        children: [/*#__PURE__*/_jsx("div", {
          className: "pure-u-5-24 pr-4",
          children: /*#__PURE__*/_jsx("div", {
            className: "px-4 pt-6",
            children: /*#__PURE__*/_jsx(CategoryFilters, {
              context: props.context,
              filterDetails: props.serverResponse.filters.filter(function (item) {
                return item.filterType === FilterTypes.Category;
              })[0],
              showPaginatedFilters: true
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "pure-u-19-24 pt-8",
          children: [/*#__PURE__*/_jsx(ProductStackList, {
            siaList: props.serverResponse.sias,
            context: props.context,
            sourceType: PageTypes.MARKETPLACE_COLLECTION_PAGE,
            sourceName: props.serverResponse.siaCollection.title,
            pageOffset: (props.currPage - 1) * DEFAULT_PAGINATION_LIMIT
          }), /*#__PURE__*/_jsx(UtilsSeparator, {
            spacingTop: DIMENSIONS.px_60,
            spacingBottom: DIMENSIONS.px_32,
            color: "gainsboro"
          }), /*#__PURE__*/_jsx(Pagination, {
            pathname: props.context.pathname,
            query: props.context.query,
            currentPage: props.currPage,
            totalCount: props.serverResponse.siasCount
          })]
        })]
      })
    })]
  });
}
export function MobileCollectionPage(props) {
  var _props$serverResponse3, _props$serverResponse4;

  var _useInfiniteQuery = useInfiniteQuery(['getCollectionProducts', props.context.params[1], JSON.stringify(props.context.query)], function (_ref) {
    var _ref$pageParam = _ref.pageParam,
        pageParam = _ref$pageParam === void 0 ? 2 : _ref$pageParam;
    return fetchProductsForPages(pageParam, props.context);
  }, {
    enabled: props.serverResponse.sias.length !== props.serverResponse.siasCount
  }),
      data = _useInfiniteQuery.data,
      fetchNextPage = _useInfiniteQuery.fetchNextPage,
      isLoading = _useInfiniteQuery.isLoading;

  useEffect(function () {
    if (data && data.pages && data.pages.length) {
      var siaCategoriesHierarchy = [];
      data.pages[data.pages.length - 1].sias.forEach(function (sia) {
        var _sia$itemDetail$categ2;

        (_sia$itemDetail$categ2 = sia.itemDetail.categoriesTree) === null || _sia$itemDetail$categ2 === void 0 ? void 0 : _sia$itemDetail$categ2.forEach(function (categoryTreeItem) {
          var l0Category = categoryTreeItem.filter(function (item) {
            return item.level === 0;
          })[0];
          var l1Category = categoryTreeItem.filter(function (item) {
            return item.level === 1;
          })[0];
          var l2Category = categoryTreeItem.filter(function (item) {
            return item.level === 2;
          })[0];
          siaCategoriesHierarchy.push("".concat(l0Category.name, " > ").concat(l1Category.name, " > ").concat(l2Category.name));
        });
      });
      var payload = {
        eventType: RetailEventTypes.CATEGORY_PAGE_VIEW,
        pageViewId: props.serverResponse.siaCollection.usId,
        pageCategories: siaCategoriesHierarchy,
        productDetails: data.pages[data.pages.length - 1].sias.map(function (sia) {
          if (sia.itemDetail.variations && sia.itemDetail.variations.length) {
            return {
              product: {
                id: "sia-".concat(sia._id, "-var-").concat(sia.itemDetail.variations[0].uuid)
              }
            };
          }

          return {
            product: {
              id: "sia-".concat(sia._id)
            }
          };
        })
      };

      if (props.userId) {
        payload.userInfo = {
          userId: props.userId
        };
      }

      trackGARetailEvent(payload);
    }
  }, [data]);
  useEffect(function () {
    var siaCollection = props.serverResponse.siaCollection;
    sendAmplitudeData(AmplitudeEventNames.PAGE_VIEWED, {
      page_type: PageTypes.MARKETPLACE_COLLECTION_PAGE,
      page_name: siaCollection.title,
      page_identifier: siaCollection.usId,
      page_num: props.currPage,
      price_filter: getQueryValueAsString(props.context.query, PriceFilterKey),
      discount_filter: getQueryValueAsString(props.context.query, DiscountFilterKey),
      sort_filter: getQueryValueAsString(props.context.query, SortByKey),
      category_filter: getQueryValueAsString(props.context.query, CategoryFilterKey),
      source: getQueryValueAsString(props.context.query, SourceKey),
      source_name: getQueryValueAsString(props.context.query, SourceNameKey)
    });
  }, []);

  var onNextClick = function onNextClick(nextPage) {
    fetchNextPage({
      pageParam: nextPage
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(BasicSEO, {
      title: props.serverResponse.siaCollection.seoMeta ? props.serverResponse.siaCollection.seoMeta.title : props.serverResponse.siaCollection.title,
      description: ((_props$serverResponse3 = props.serverResponse.siaCollection.seoMeta) === null || _props$serverResponse3 === void 0 ? void 0 : _props$serverResponse3.description) || props.serverResponse.siaCollection.info || '',
      keywords: ((_props$serverResponse4 = props.serverResponse.siaCollection.seoMeta) === null || _props$serverResponse4 === void 0 ? void 0 : _props$serverResponse4.keywords) || ''
    }), /*#__PURE__*/_jsx(CollectionHero, {
      page: props.serverResponse.siaCollection,
      filters: props.serverResponse.filters,
      context: props.context,
      siasCount: props.serverResponse.siasCount
    }), /*#__PURE__*/_jsxs("div", {
      className: "page-cushion-container pt-4",
      children: [/*#__PURE__*/_jsx(ProductStackList, {
        siaList: props.serverResponse.sias,
        context: props.context,
        sourceType: PageTypes.MARKETPLACE_COLLECTION_PAGE,
        sourceName: props.serverResponse.siaCollection.title,
        pageOffset: 0
      }), data && data.pages && data.pages.map(function (page, idx) {
        return /*#__PURE__*/_jsx(ProductStackList, {
          siaList: page.sias,
          context: props.context,
          sourceType: PageTypes.MARKETPLACE_COLLECTION_PAGE,
          sourceName: page.siaCollection.title,
          pageOffset: (idx + 1) * DEFAULT_PAGINATION_LIMIT
        }, page.siaCollection.title);
      })]
    }), data && data.pages && data.pages.length + 1 < props.serverResponse.siasCount / DEFAULT_PAGINATION_LIMIT ? /*#__PURE__*/_jsx(UtilsInfiniteScroll, {
      currPage: data.pages.length + 1,
      callback: onNextClick,
      gridCount: props.context.isMobileView ? 2 : 7,
      disableDefaultGutter: true
    }) : null, /*#__PURE__*/_jsxs(UtilsStickyBottomCta, {
      className: "mt-12",
      usePositionFixed: true,
      children: [/*#__PURE__*/_jsx(SortFilterModalSheet, {
        context: props.context
      }), /*#__PURE__*/_jsx(FilterModalDialog, {
        context: props.context,
        filters: props.serverResponse.filters
      })]
    })]
  });
}
export function CollectionPage(props) {
  return /*#__PURE__*/_jsxs(GlobalContextWrapper, {
    context: props.context,
    showCuratedCategories: true,
    children: [props.context.isMobileView ? /*#__PURE__*/_jsx(MobileCollectionPage, _objectSpread({}, props)) : /*#__PURE__*/_jsx(DesktopCollectionPage, _objectSpread({}, props)), props.context.isMobileView ? /*#__PURE__*/_jsx(MobileFooter, {}) : /*#__PURE__*/_jsx(DesktopFooter, {})]
  });
}
export default CollectionPage;